
import React, {Component, Fragment} from 'react'
import { IoNotificationsOutline } from "react-icons/io5";
import { Button } from 'reactstrap';
import Select from 'react-select';

var storefrontUtility = require('../../../utils/domain/storefrontUtility');
var formatter = require('../../../utils/formatter/formatter.js');
var flipdishManualSaleAcceptanceTimeCalculator = require('../../../utils/domain/sales/flipdishManualSaleAcceptanceTimeCalculator');
var saleCalculator = require('../../../utils/domain/sales/saleCalculator');
var stringUtil = require('../../../utils/string/stringUtil');
var staffUtility = require('../../../utils/domain/staff/staffUtility');
var staffAccessUtility = require('../../../utils/domain/staff/staffAccessUtility');
var staffActivities = require('../../../utils/domain/staff/staffActivities');
var translator = require('../../../utils/translator/translator.js');
var viewUtil = require('../../../utils/view/viewUtil');
var logger = require('../../../utils/logger/logger');
var guidUtil = require('../../../utils/guid/guidUtil');
var dateUtil = require('../../../utils/dateUtil/dateUtil');
var jobsServer = require('../../../utils/jobs/jobsServer');
var rmsApiProxyRetry = require('../../../utils/api/rmsApiProxyRetry');
var userNotificationsUtil = require('../../../utils/userNotifications/userNotificationsUtil');

const customStyles = 
        {
            control: (provided, state) => ({
                ...provided,
                minHeight: '6vh',
                height: '6vh',
                borderColor: 'var(--colors-primary)',
            }),
            menu: provided => ({ ...provided, zIndex: 9999}),
        };

class NotificationDetail extends Component 
{
    constructor(props)
    {
        super(props);
        this.onReject = this.onReject.bind(this);
        this.onAccept = this.onAccept.bind(this);

        this.state = {};

        this.state.rejectionReasons = [
                                            {value:"Store Is Too Busy", label:'Store Is Too Busy'},
                                            {value:"Store Closed", label:'Store Closed'},
                                            {value:"Items Out Of Stock", label:'Items Out Of Stock'},
                                        ]

        this.state.additionalTimes = 
                                        [
                                            {value:0, label:'As Expected'},
                                            {value:15, label:'Add 15 minutes'},
                                            {value:30, label:'Add 30 minutes'},
                                            {value:45, label:'Add 45 minutes'},
                                            {value:60, label:'Add 60 minutes'},
                                            {value:75, label:'Add 75 minutes'},
                                            {value:90, label:'Add 90 minutes'},
                                            {value:105, label:'Add 105 minutes'},
                                            {value:120, label:'Add 120 minutes'},
                                        ]
    }

    render()
    {
        return <div style={{border:'1px solid #B0B0B0'}}>
                    <table width="100%">
                        <tr>
                            <td align="center">
                                <div style={{paddingTop:'5px', paddingBottom:'5px', background:'var(--colors-primary)', color:'var(--colors-white)'}}>
                                    <table>
                                        <tr>
                                            <td>
                                                <IoNotificationsOutline size={28}/>
                                            </td>
                                            <td>
                                                <div style={{marginLeft:'5px', fontSize:'1.5rem'}}>{translator.getLabel("new_order")}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>

                        {this.renderError()}

                        <tr>
                            <td>
                                <div style={{marginLeft:'20px', marginRight:'20px', marginTop:'30px'}}>
                                    {this.renderToolbar()}
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <hr style={{marginTop:'30px', marginBottom:'30px'}}/>
                            </td>
                        </tr>
                        

                        <tr>
                            <td>
                                <div style={{marginLeft:'20px', marginRight:'20px'}}>
                                    {this.renderOrder()}
                                </div>
                            </td>
                        </tr>

                        


                </table>
            </div>
    }

    renderError()
    {
        if (!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
        {
            return <Fragment>
                            <tr>
                                <td>
                                    <div style={{color:'darkred', textAlign:'center', fontSize:'1.2rem', marginTop:'10px'}}>
                                        {translator.getLabel("not_sufficient_privileges_to_place_an_order")}
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'5px'}}/>
                                </td>
                            </tr>
                        </Fragment>
        }

        if (this.isNotificationExpired())
        {
            return <Fragment>
                            <tr>
                                <td>
                                    <div style={{color:'darkred', textAlign:'center', fontSize:'1.2rem', marginTop:'10px'}}>
                                        Order Expired At {dateUtil.formatDate(this.props.notification.expiryDateTime, "HH:mm")}
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'5px'}}/>
                                </td>
                            </tr>
                        </Fragment>
        }

        return null;
    }

    renderToolbar()
    {
        var disabled = false;
        if (staffUtility.getLoginStaff() == null || 
            !staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder) ||
            this.isNotificationExpired())
            disabled = true;

        return <div className='w-100 d-flex flex-column justify-content-center align-content-center'>
                    <div className='w-100 d-flex flex-row justify-content-center align-content-center'>
                        <div style={{width:'80%'}}>
                            <Select 
                                value={this.state.selectedAdditionalTime}
                                options={this.state.additionalTimes}
                                placeholder="Order Time" 
                                isSearchable={false}
                                isClearable={true}
                                isDisabled={disabled}
                                onChange={(selectedValue) =>
                                    {
                                        if (selectedValue == null)
                                        {
                                            this.state.selectedAdditionalTime = null;
                                            this.setState({});
                                            return;
                                        }
                                        this.state.selectedAdditionalTime = selectedValue;
                                        this.setState({});
                                    }}
                                styles={customStyles}/>
                        </div>
                        <div style={{width:'20%', marginLeft:'20px', textAlign:'end'}}>
                            <Button className='btn-action' disabled={disabled || this.state.selectedAdditionalTime == null}
                                    onClick={this.onAccept}>
                                Accept
                            </Button>
                        </div>
                    </div>

                    <div className='w-100 d-flex flex-row justify-content-center align-content-center' style={{marginTop:'10px'}}>
                        <div style={{width:'80%'}}>
                            <Select 
                                value={this.state.selectedRejectionReason}
                                options={this.state.rejectionReasons}
                                placeholder="Rejection Reason" 
                                isSearchable={false}
                                isClearable={true}
                                isMulti={false}
                                isDisabled={disabled}
                                onChange={(selectedValue) =>
                                    {
                                        if (selectedValue == null)
                                        {
                                            this.state.selectedRejectionReason = null;
                                            this.setState({});
                                            return;
                                        }
                                        this.state.selectedRejectionReason = selectedValue;
                                        this.setState({});
                                    }}
                                styles={customStyles}/>
                        </div>
                        <div style={{width:'20%', marginLeft:'20px', textAlign:'end'}}>
                            <Button className='btn-action' disabled={disabled || this.state.selectedRejectionReason == null}
                                    onClick={this.onReject}>
                                Reject
                            </Button>
                        </div>
                    </div>
                </div>
    }

    renderOrder()
    {
        var sale = this.props.notification.payload;
        var storefront = storefrontUtility.getStorefrontById(sale.storefrontId);

        return <div>
                    <table width="100%">
                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Order Number
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {sale.number}
                            </td>
                        </tr>

                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Sale Time
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {dateUtil.formatDate(sale.dateTime, "HH:mm")}
                            </td>
                        </tr>

                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Storefront
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {storefront.name}
                            </td>
                        </tr>

                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Dispatch
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {sale.dispatchType}
                            </td>
                        </tr>

                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Sale Price
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {formatter.convertToCurrencyFormat(saleCalculator.calculateTotalSalePrice(sale))}
                            </td>
                        </tr>

                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Expected Time
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {flipdishManualSaleAcceptanceTimeCalculator.getFormattedDateTimeToLocalTime(
                                    flipdishManualSaleAcceptanceTimeCalculator.getExpectedHandoverTime(sale, this.state.selectedAdditionalTime == null ? 0 : this.state.selectedAdditionalTime.value)
                                    )}
                            </td>
                        </tr>

                        <tr style={{borderBottom:'1px solid #D0D0D0'}}>
                            <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                Payment Status
                            </td>
                            <td style={{width:'99%', textAlign:'right'}}>
                                {saleCalculator.isSaleFullyPaid(sale) ? "Paid" : "NOT Paid"}
                            </td>
                        </tr>

                        {this.renderDispatchInfo(sale)}

                    </table>
            
            <div style={{marginTop:'40px', marginBottom:'20px', marginLeft:'10px', marginRight:'10px', background:'var(--background-color)', border:'1px solid #B8B8B8', padding:'10px'}}>
                {this.renderSale(sale)}
            </div>
        </div>
        
    }

    renderDispatchInfo(sale)
    {
        let dispatchInfo = sale.dispatchInfo;
        if (stringUtil.isStringNullOrEmpty(dispatchInfo))
            return null;

        let components = [];
        dispatchInfo = JSON.parse(dispatchInfo);


        if (dispatchInfo != null && !stringUtil.isStringNullOrEmpty(dispatchInfo.customerName))
        {   
            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                    <div style={{marginTop:'20px'}}>{translator.getLabel("customer_name")}</div>
                                </td>
                                <td style={{width:'99%', textAlign:'right'}}>
                                    <div style={{marginTop:'20px'}}>{dispatchInfo.customerName}</div>
                                </td> 
                            </tr>)
        }

        if (dispatchInfo != null && !stringUtil.isStringNullOrEmpty(dispatchInfo.customerPhoneNumber))
        {   
            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                {translator.getLabel("customer_phone_number")}
                                </td>
                                <td style={{width:'99%', textAlign:'right'}}>
                                    {dispatchInfo.customerPhoneNumber}
                                </td> 
                            </tr>)
        }

        if (dispatchInfo != null && !stringUtil.isStringNullOrEmpty(dispatchInfo.deliveryAddress))
        {   
            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                {translator.getLabel("delivery_address")}
                                </td>
                                <td style={{width:'99%', textAlign:'right'}}>
                                    {dispatchInfo.deliveryAddress}
                                </td> 
                            </tr>)
        }

        if (dispatchInfo != null && !stringUtil.isStringNullOrEmpty(dispatchInfo.distance))
        {   
            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'start'}}>
                                {translator.getLabel("delivery_distance")}
                                </td>
                                <td style={{width:'99%', textAlign:'right'}}>
                                    {dispatchInfo.distance}
                                </td> 
                            </tr>)
        }

        if (components.length > 0)
        {
            return <Fragment>{components}</Fragment>
        }
    }

    renderSale(sale)
    {
        var components = [];

        sale.saleItems.forEach (saleItem =>
        {
            this.renderSaleItem(sale, saleItem, components, saleItem, 0);
            components.push(<tr><td colSpan="3"><hr style={{marginTop:'0px', marginBottom:'10px'}}/></td></tr>)
        });
        
        return (<table width="100%">
                    {components}
        </table>)
    }

    renderSaleItem(sale, saleItem, components, rootItem, marginLeft)
    {
        var formattedPrice = "";

        if (!stringUtil.isStringNullOrEmpty(saleItem.unitPrice) && saleItem.unitPrice > 0)
            formattedPrice = formatter.convertToCurrencyFormat(saleItem.unitPrice * saleItem.quantity);

        var backgroundColor = null;
        var foregroundColor = null;
        if (!stringUtil.isStringNullOrEmpty(saleItem.backgroundColor))
            backgroundColor = saleItem.backgroundColor;
        if (!stringUtil.isStringNullOrEmpty(saleItem.foregroundColor))
            foregroundColor = saleItem.foregroundColor;

        var textDecoration = null;
        if (saleItem.isRefunded)
            textDecoration= 'line-through';

        var caption = saleItem.caption;
        
        if (!stringUtil.isStringNullOrEmpty(saleItem.instructions))
            caption = `${caption} ♨`

        components.push( <tr>


                            <td  style={{minWidth:'30px'}}>
                                {saleItem == rootItem ? saleItem.quantity : ''}
                            </td>
                            <td width="99%">
                                <span style={{marginLeft:marginLeft, background:backgroundColor, color:foregroundColor, padding:'2px', textDecoration:textDecoration}}>{caption}</span> 
                            </td>
                            <td  style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                <div style={{marginRight:'5px', textDecoration:textDecoration}}>{formattedPrice}</div>
                            </td>
                        </tr>);

        saleItem.saleItems.forEach(subItem =>
            {
                this.renderSaleItem(sale, subItem, components, rootItem, marginLeft+20);
            })
    }

    onReject()
    {
        var sale = this.props.notification.payload;
        var notificationId = this.props.notification.id;

        if (this.state.selectedRejectionReason == null)
            return;

        viewUtil.showPrompt(translator.getLabel("order_reject"), `${translator.getLabel("you_are_about_to_reject_order")} (${sale.number}).`, translator.getLabel("are_you_sure"),
        ()=>
        {
            const notificationResponse = { type: "manual.accept.order", action: "reject", reason: this.state.selectedRejectionReason.value};

            logger.info(`User rejected the order for order number: ${sale.number}. with reason as ${this.state.selectedRejectionReason.value}`);
            jobsServer.addJob(guidUtil.generateGuid(), "Manual.Order.Reject", 
            async ()=>
            {
                return rmsApiProxyRetry.post(`${rmsApiProxyRetry.getOrgContextToUrl()}/userNotifications/${notificationId}`, notificationResponse);
            });
    
            viewUtil.clearAlertForId(notificationId);
            userNotificationsUtil.deleteAndPublishNotification(notificationId);
        })
    }

    onAccept()
    {
        var notificationId = this.props.notification.id;
        var sale = this.props.notification.payload;

        if (this.state.selectedAdditionalTime == null)
            return;

        const handOverDateTime = flipdishManualSaleAcceptanceTimeCalculator.getExpectedHandoverTime(sale, this.state.selectedAdditionalTime.value);
        let estimatedTimeInMinutes = dateUtil.differenceInMinutes(handOverDateTime, dateUtil.getNow());
        if(estimatedTimeInMinutes < 0) estimatedTimeInMinutes = 0;
        estimatedTimeInMinutes = Math.ceil(estimatedTimeInMinutes);
        const notificationResponse = { type: "manual.accept.order", action: "accept", estimatedTime: estimatedTimeInMinutes };

        logger.info(`User accepted the order for order number: ${sale.number} with selected additional time as '${this.state.selectedAdditionalTime.value}'. The estimated time in minutes is ${estimatedTimeInMinutes}`);
        jobsServer.addJob(guidUtil.generateGuid(), "Manual.Order.Accept", 
        async ()=>
        {
            return rmsApiProxyRetry.post(`${rmsApiProxyRetry.getOrgContextToUrl()}/userNotifications/${notificationId}`, notificationResponse);
        });

        viewUtil.clearAlertForId(notificationId);
        userNotificationsUtil.deleteAndPublishNotification(notificationId);
    }

    isNotificationExpired()
    {
        let notification = this.props.notification;
        return dateUtil.isBefore(notification.expiryDateTime, dateUtil.getNow());
    }

    
}

export default NotificationDetail